// import jwtDecode from 'jwt-decode';

import { ACCESS_TOKEN, REFRESH_TOKEN, PROVIDER_ID, USER_TYPE } from './constants';

export const saveAllTokens = (data) => {
  localStorage.setItem(ACCESS_TOKEN, data.accessToken);
  localStorage.setItem(REFRESH_TOKEN, data.refreshToken);
};
export const removeAllTokens = () => {
  localStorage.clear(ACCESS_TOKEN);
  localStorage.clear(REFRESH_TOKEN);
  localStorage.clear(PROVIDER_ID);
  localStorage.clear(USER_TYPE);
};
